import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import Input from '../../../../components/Input'
import Button from '../../../../components/Button'
import Card from '../../../../components/Card'

type Props = {
  onSubmit: Function,
  submitting: boolean,
  handleSubmit: Function
}

class PasswordForm extends Component {
  props: Props

  handleSubmit = (data) => this.props.onSubmit({ password: data.password })

  render() {
    const { handleSubmit, submitting } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Card>
          <h5>Password</h5>
          <hr />
          <Field
            type="password"
            name="password"
            component={Input}
            label="New password"
            style={{ marginBottom: '1rem' }}
          />
          <Field
            type="password"
            component={Input}
            label="Confirm password"
            name="passwordConfirmation"
            style={{ marginBottom: '1rem' }}
          />
          <Button color="primary" disabled={submitting} animating={submitting}>
            Update password
          </Button>
        </Card>
      </form>
    )
  }
}

const validate = (values) => {
  const errors = {}
  if (values.password && values.password.length < 6) {
    errors.password = 'Minimum of 6 characters'
  }
  if (
    (values.password || values.passwordConfirmation) &&
    values.password !== values.passwordConfirmation
  ) {
    errors.passwordConfirmation = 'Passwords do not match'
  }
  return errors
}

export default reduxForm({
  form: 'updatePassword',
  validate
})(PasswordForm)



// WEBPACK FOOTER //
// ./src/views/UserSettings/components/PasswordForm/index.js